import { useState, useEffect, useCallback } from 'react';
import { checkRealConnectivity } from '@/lib/offline/connectivity';

const PING_INTERVAL = 15000;

export const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const updateStatus = useCallback(async () => {
    const realOnline = await checkRealConnectivity();
    setIsOnline(realOnline);
  }, []);

  useEffect(() => {
    // Check real al montar
    updateStatus();

    // offline es inmediato, no necesita ping
    const handleOffline = () => setIsOnline(false);
    // online necesita verificar si hay internet real
    const handleOnline = () => updateStatus();

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Polling para detectar pérdida silenciosa (edificio sin señal, etc.)
    const interval = setInterval(updateStatus, PING_INTERVAL);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      clearInterval(interval);
    };
  }, [updateStatus]);

  return isOnline;
};